import React, { useState } from 'react';
import { Formik, FormikHelpers } from 'formik';
import { useHistory } from 'react-router-dom';

import { buildCreateCompany } from '../../../lib/services/company.service';
import { buildSendInviteToCompany } from '../../../lib/services/invite.service';
import { buildUpdateUserSettings } from '../../../lib/services/user.service';
import { TIMEZONE_NAME_OPTIONS } from '../../../lib/timezone.constants';
import { HOME_ROUTE, MEMBER_GROUP_ROLES, MemberListType } from '../../../../_configuration';
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { messages } from './admin.messages';
import { CreateAssociationForm } from './create-association-form.component';
import { validationSchema } from './create-association-form.validation';
import { ICreateAssociationFields } from './create-association-form.types';

const SUPER_USER_MEMBER_ROLES = [{ roles: MEMBER_GROUP_ROLES[MemberListType.SUPER] }];

export const CreateAssociationFormContainer = () => {
  const [submitError, setSubmitError] = useState<React.ReactNode>(null);

  const { createCompany } = buildCreateCompany();
  const { sendInviteToCompany } = buildSendInviteToCompany();
  const { updateUserSettings } = buildUpdateUserSettings();
  const history = useHistory();

  const initialValues: ICreateAssociationFields = {
    name: '',
    timezone: TIMEZONE_NAME_OPTIONS[0],
    ownerEmail: '',
  };

  const handleSubmit = async (
    values: ICreateAssociationFields,
    { setSubmitting }: FormikHelpers<ICreateAssociationFields>,
  ) => {
    setSubmitError(null);

    try {
      const result = await createCompany({ name: values.name.trim(), timezone: values.timezone.value });
      const company = result?.data?.createCompany;

      if (!company?._id) throw new Error('Association was not created');

      await sendInviteToCompany(company._id, values.ownerEmail.toLowerCase(), SUPER_USER_MEMBER_ROLES);

      // Waits for the switch so the dashboard opens in the new association; a refused switch reports itself.
      await updateUserSettings({ activeCompanyId: company._id });
      history.push(HOME_ROUTE);
    } catch (err) {
      console.error('createAssociation failed:', err);
      setSubmitError(<IntlMsg {...messages.errCreateAssociation} />);
      setSubmitting(false);
    }
  };

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
      {() => <CreateAssociationForm submitError={submitError} />}
    </Formik>
  );
};
